export default {
  data() {
    return {
      id: this.$route.params.agency_id
    }
  },
  methods: {
    clicked(value) {
      alert(value);
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/automation/automationMixin.js